import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import OfferGroupsRepository from "repositories/OfferGroupsRepository";
import { deserialize } from "utils/storeUtils";

const initialState = {
  offerGroups: [],
  errors: null,
};

const offerGroupsSlice = createSlice({
  name: "offerGroups",
  initialState,
  reducers: {
    loadOfferGroupsSuccess(state, { payload }) {
      state.offerGroups = deserialize(payload);
    },
    loadOfferGroupsFail(state, { payload }) {
      state.errors = payload;
    },
  },
});

export const { actions } = offerGroupsSlice;
export default offerGroupsSlice.reducer;

export const useOfferGroupsActions = () => {
  const dispatch = useDispatch();

  const loadOfferGroups = async () => {
    try {
      const { data } = await OfferGroupsRepository.index();
      dispatch(offerGroupsSlice.actions.loadOfferGroupsSuccess(data));
    } catch (error) {
      dispatch(offerGroupsSlice.actions.loadOfferGroupsFail(error));
      throw new Error(error);
    }
  };

  return {
    loadOfferGroups,
  };
};
